import { render } from "./yard9.vue?vue&type=template&id=272c3816&scoped=true"
import script from "./yard9.vue?vue&type=script&lang=js"
export * from "./yard9.vue?vue&type=script&lang=js"

import "./yard9.vue?vue&type=style&index=0&id=272c3816&lang=css"
import "./yard9.vue?vue&type=style&index=1&id=272c3816&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272c3816"]])

export default __exports__